<div class="agenda-container">
  <!-- Header Section -->
  <div class="header-section">
    <div class="page-title">Próximas sesiones</div>
    <div class="page-subtitle">Mira la lista de tus próximas sesiones aquí</div>
  </div>

  <!-- Filter Section -->
  <div class="filter-section">
    <div class="filter-row">
      <div class="filter-group">
        <input type="text" class="search-input" placeholder="Buscar por nombre" [(ngModel)]="searchTerm" (input)="onSearchChange()" /> 
        <svg class="search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" > 
          <circle cx="11" cy="11" r="8"></circle>
          <path d="m21 21-4.35-4.35"></path>
        </svg>
      </div>

      <!-- 
      <div class="filter-group">
        <select class="filter-select" [(ngModel)]="statusFilter" (change)="onFilterChange()">
          <option value="">Filtrar estado</option>
          <option value="pending">Pendiente</option>
          <option value="completed">Completada</option>
          <option value="cancelled">Cancelada</option>
        </select>
        <svg class="dropdown-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6,9 12,15 18,9"></polyline>
        </svg>
      </div>

      <div class="filter-group">
        <select class="filter-select" [(ngModel)]="stageFilter" (change)="onFilterChange()">
          <option value="">Filtrar etapa</option>
          <option value="Análisis profundo">Análisis profundo</option>
          <option value="Mapa de identidad">Mapa de identidad</option>
          <option value="Phoenix Session">Phoenix Session</option>
          <option value="Visionboard">Visionboard</option>
          <option value="Phoenix Session">Phoenix Session</option>
          <option value="PRD">PRD</option>
          <option value="Plan de vida">Plan de vida</option>
          <option value="Graduación">Graduación</option>
        </select>
        <svg class="dropdown-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="6,9 12,15 18,9"></polyline>
        </svg>
      </div> 
      -->

      <div class="filter-group">
        <app-custom-date-picker [(ngModel)]="dateFromFilter" (dateChange)="onFilterChange()" placeholder="Filtrar citas desde" >
        </app-custom-date-picker>
      </div>

      <div class="filter-group">
        <app-custom-date-picker [(ngModel)]="dateToFilter" (dateChange)="onFilterChange()" placeholder="Filtrar citas hasta" >
        </app-custom-date-picker>
      </div>
    </div>
  </div>

  <!-- Table Section -->
  <div class="table-container">
    <table class="sessions-table">
      <thead>
        <tr>
          <th class="sortable" (click)="sortBy('menteeName')">
            Mentoreado
            <svg class="sort-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" >
              <polyline points="6,9 12,15 18,9"></polyline>
            </svg>
          </th>
          <th class="sortable" (click)="sortBy('date')">
            Fecha
            <svg class="sort-icon" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" > 
              <polyline points="6,9 12,15 18,9"></polyline>
            </svg>
          </th>
          <th>Hora</th>
          <th>Duración</th>
          <th *ngIf="!isExpertUser()">Hito</th>
          <th>Notas</th>
          <th>Acciones</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let session of paginatedSessions; let i = index" class="session-row" >
          <td class="mentee-cell">
            <div class="mentee-info">
              <div class="mentee-avatar">
                <img [src]="
                    session.menteeAvatar || '/assets/icons/default-avatar.png'
                  "
                  [alt]="session.menteeName"
                  class="avatar-img"
                />
              </div>
              <span class="mentee-name">{{ session.menteeName }}</span>
            </div>
          </td>
          <td class="date-cell">{{ session.date | date : "dd/MM/yyyy" }}</td>
          <td class="time-cell">{{ session.time }}</td>
          <td class="duration-cell">{{ session.duration }} minutos</td>
          <td class="milestone-cell" *ngIf="!isExpertUser()">{{ session.milestone }}</td>
          <td class="notes-cell">
            <button class="notes-btn" (click)="openNotesModal(session)">
              <i class="fas fa-sticky-note"></i>
              {{ session.notes ? "Ver notas" : "Agregar notas" }}
            </button>
          </td>
          <td class="action-cell">
            <div class="action-buttons">
              <button class="enter-session-btn" (click)="enterSession(session)">
                Ingresar a sesión
              </button>
              <button
                class="delete-session-btn"
                (click)="deleteSession(session)"
              >
                Eliminar
              </button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <!-- Modal para notas de citas -->
  <div class="modal-overlay" *ngIf="showNotesModal" (click)="closeNotesModal()">
    <div class="modal-container notes-modal" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3 class="modal-title">Notas de la sesión</h3>
        <p class="modal-subtitle">
          Registra observaciones y adjunta documentos para la sesión del
          {{ selectedAppointment?.date | date : "dd/MM/yyyy" }} a las
          {{ selectedAppointment?.time || "" | timeFormat }}
        </p>
        <button class="close-modal-btn" (click)="closeNotesModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <div class="modal-content notes-content">
        <!-- Editor de texto enriquecido -->
        <div class="notes-editor-section">
          <!-- Toolbar personalizado para funcionalidades adicionales -->
          <div class="custom-toolbar">
            <div class="toolbar-group">
              <button
                class="toolbar-btn"
                (click)="togglePreview()"
                [class.active]="showPreview"
              >
                <i class="fas fa-eye"></i>
                Vista previa
              </button>
              <button class="toolbar-btn" (click)="clearQuillEditor()">
                <i class="fas fa-eraser"></i>
                Limpiar
              </button>
            </div>
          </div>

          <div class="editor-content">
            <!-- Editor Quill -->
            <div
              #quillEditor
              class="quill-editor"
              [style.display]="showPreview ? 'none' : 'block'"
            >
              <div *ngIf="!quillInstance" class="quill-loading"></div>
            </div>

            <!-- Vista previa -->
            <div
              *ngIf="showPreview"
              class="preview-content"
              [innerHTML]="appointmentNotes"
            ></div>
          </div>
        </div>

        <!-- Sección de carga de archivos -->
        <div class="file-upload-section">
          <div class="file-upload-header">
            <h4 class="file-upload-title">Cargar archivos</h4>
            <button class="upload-file-btn" (click)="triggerFileUpload()">
              <i class="fas fa-cloud-upload-alt"></i>
              Subir archivo
            </button>
          </div>

          <input
            type="file"
            #fileInput
            id="fileInput"
            (change)="onFileSelected($event)"
            multiple
            accept=".pdf,.doc,.docx,.ppt,.pptx,.txt,.jpg,.jpeg,.png"
            style="display: none"
          />

          <div class="files-list" *ngIf="appointmentFiles.length > 0">
            <div class="files-table">
              <div class="files-header">
                <div class="file-name-header">Nombre del archivo</div>
                <div class="file-date-header">Fecha</div>
                <div class="file-actions-header">Acciones</div>
              </div>

              <div class="files-body">
                <div
                  class="file-item"
                  *ngFor="let file of appointmentFiles; let i = index"
                >
                  <div class="file-name">
                    <i
                      class="fas fa-file"
                      [class]="getFileIconClass(file.name)"
                    ></i>
                    {{ file.name }}
                  </div>
                  <div class="file-date">
                    {{ file.uploadDate | date : "dd/MM/yyyy" }}
                  </div>
                  <div class="file-actions">
                    <button
                      class="action-btn view-btn"
                      (click)="viewFile(file)"
                      title="Ver archivo"
                    >
                      <i class="fas fa-eye"></i>
                    </button>
                    <button
                      class="action-btn delete-btn"
                      (click)="deleteFile(i)"
                      title="Eliminar archivo"
                    >
                      <i class="fas fa-trash"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="no-files" *ngIf="appointmentFiles.length === 0">
            <i class="fas fa-file-upload"></i>
            <p>No hay archivos adjuntos</p>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button class="btn-cancel" (click)="closeNotesModal()">Cancelar</button>
        <button
          class="btn-save"
          (click)="saveAppointmentNotes()"
          [disabled]="isSavingNotes"
        >
          <i class="fas fa-save" *ngIf="!isSavingNotes"></i>
          <i class="fas fa-spinner fa-spin" *ngIf="isSavingNotes"></i>
          {{ isSavingNotes ? "Guardando..." : "Guardar" }}
        </button>
      </div>
    </div>
  </div>

  <!-- Pagination Section -->
  <div class="pagination-container" *ngIf="totalPages > 1">
    <div class="pagination-info">
      Mostrando {{ (currentPage - 1) * pageSize + 1 }} -
      {{ Math.min(currentPage * pageSize, filteredSessions.length) }} de
      {{ filteredSessions.length }} resultados
    </div>

    <div class="pagination-controls">
      <button
        class="pagination-btn"
        [disabled]="currentPage === 1"
        (click)="goToPage(currentPage - 1)"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="15,18 9,12 15,6"></polyline>
        </svg>
        Anterior
      </button>

      <div class="page-numbers">
        <button
          *ngFor="let page of getPageNumbers()"
          class="page-number"
          [class.active]="page === currentPage"
          (click)="goToPage(page)"
        >
          {{ page }}
        </button>
      </div>

      <button
        class="pagination-btn"
        [disabled]="currentPage === totalPages"
        (click)="goToPage(currentPage + 1)"
      >
        Siguiente
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="9,18 15,12 9,6"></polyline>
        </svg>
      </button>
    </div>

    <div class="items-per-page">
      <span>Mostrar</span>
      <select
        class="page-size-select"
        [(ngModel)]="pageSize"
        (change)="onPageSizeChange()"
      >
        <option value="5">5</option>
        <option value="10">10</option>
        <option value="20">20</option>
        <option value="50">50</option>
      </select>
    </div>
  </div>

  <!-- Availability Section -->
  <div class="availability-section">
    <div class="availability-header">
      <h2 class="availability-title">Disponibilidad</h2>
      <p class="availability-subtitle">
        Selecciona los días y horarios en los que realmente estarás disponible
        para tus sesiones. Estos serán los momentos en los que los usuarios
        podrán agendar contigo.
      </p>
    </div>

    <div class="availability-card">
      <!-- Calendar Section -->
      <div class="calendar-section">
        <div class="calendar-header">
          <button class="calendar-nav-btn" (click)="previousMonth()" type="button">
            <i class="fas fa-angle-left"></i>
          </button>
          <h3 class="calendar-month">
            {{ getCurrentMonthName() }} {{ currentYear }}
          </h3>
          <button class="calendar-nav-btn" (click)="nextMonth()" type="button">
            <i class="fas fa-angle-right"></i>
          </button>
        </div>

        <div class="calendar-grid">
          <!-- Days of week header -->
          <div class="calendar-weekdays">
            <div class="weekday" *ngFor="let day of weekDays">{{ day }}</div>
          </div>

          <!-- Calendar days -->
          <div class="calendar-days">
            <div
              *ngFor="let day of calendarDays"
              class="calendar-day"
              [class.other-month]="day.isOtherMonth"
              [class.selected]="day.isSelected"
              [class.available]="day.isAvailable"
              (click)="selectDate(day)"
            >
              {{ day.day }}
            </div>
          </div>
        </div>
      </div>

      <!-- Time Slots Section -->
      <div class="time-slots-section">
        <div class="time-slots-header">
          <h3 class="time-slots-title">Selecciona tus horas disponibles</h3>
          <p class="time-slots-subtitle">
            Marca los horarios en los que estarás disponible y asegúrate de
            elegir solo los que puedas cumplir.
          </p>
        </div>

        <div class="time-slots-grid">
          <button
            *ngFor="let timeSlot of timeSlots"
            class="time-slot-btn"
            [class.selected]="timeSlot.selected"
            (click)="toggleTimeSlot(timeSlot)"
          >
            {{ timeSlot.time }}
          </button>
        </div>
        <!-- Confirm Button -->
        <div class="availability-actions">
          <button
            class="confirm-availability-btn"
            (click)="confirmAvailability()"
          >
            Confirmar disponibilidad
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal de confirmación de disponibilidad -->
@if (showConfirmationModal) {
<div class="modal-overlay" (click)="closeConfirmationModal()">
  <div class="confirmation-modal" (click)="$event.stopPropagation()">
    <!-- Título del modal -->
    <h2 class="modal-title">¿Confirmas tu disponibilidad?</h2>

    <!-- Contenido del modal -->
    <div class="modal-content">
      <p class="modal-message">
        Estás habilitando estos horarios para que los usuarios puedan agendar
        contigo.
      </p>
      <p class="modal-message">
        Asegúrate de estar disponible en las fechas y horas seleccionadas.
      </p>
    </div>

    <!-- Botones del modal -->
    <div class="modal-actions">
      <button class="btn-cancel" (click)="closeConfirmationModal()">
        Cancelar
      </button>
      <button class="btn-confirm" (click)="proceedWithConfirmation()">
        Confirmar
      </button>
    </div>
  </div>
</div>
}

<!-- Modal de Alerta -->
<div class="modal-overlay" *ngIf="showAlertModal" (click)="closeAlertModal()">
  <div class="modal-content alert-modal" (click)="$event.stopPropagation()">
    <!-- Título del modal -->
    <div class="modal-title">
      {{ alertTitle }}
    </div>

    <!-- Mensaje del modal -->
    <div class="modal-message">
      {{ alertMessage }}
    </div>

    <!-- Botón del modal -->
    <div class="modal-actions">
      <button class="btn-confirm" (click)="closeAlertModal()">Aceptar</button>
    </div>
  </div>
</div>
